import React, { useEffect, useState } from "react";
import { api, dateFormat, euroFormat } from "../../lib/api";

export default function Vollzahlungen() {
  const [items, setItems] = useState([]);
  const load = () => api.get("/admin/empfehlungen/fertig-ohne-vollzahlung").then((r) => setItems(r.data));
  useEffect(() => { load(); }, []);

  const setVollzahlung = async (eid) => {
    const datum = prompt("Vollzahlungs-Datum (YYYY-MM-DD)", new Date().toISOString().slice(0, 10));
    if (!datum) return;
    await api.post(`/admin/empfehlungen/${eid}/vollzahlung`, { vollzahlung_am: datum + "T00:00:00+00:00" });
    load();
  };

  return (
    <div className="space-y-5" data-testid="vollzahlungen-page">
      <h1 className="text-3xl font-heading font-bold text-falke-blue">Vollzahlungen erfassen</h1>
      <p className="text-sm text-falke-anthracite/70">Empfehlungen im Status „Fertig" ohne Vollzahlungs-Datum. Setzen startet den 7-Tage-Timer.</p>
      {items.length === 0 ? (
        <div className="falke-card p-10 text-center text-falke-anthracite/60">Keine offenen Vollzahlungen.</div>
      ) : (
        <div className="falke-card divide-y divide-falke-blue/10">
          {items.map((e) => (
            <div key={e.id} className="flex flex-wrap items-center gap-4 p-5" data-testid={`voll-${e.id}`}>
              <div className="flex-1 min-w-0">
                <div className="font-semibold text-falke-blue">{e.empfohlener_name}</div>
                <div className="text-sm text-falke-anthracite/70">Empfehler: {e.empfehler_name} · Status seit {dateFormat(e.letzter_status_wechsel_am)}</div>
                <div className="text-sm text-falke-blue tabular">Auftragswert: {euroFormat(e.auftragswert_netto)} (netto)</div>
              </div>
              <button onClick={() => setVollzahlung(e.id)} className="btn-primary" data-testid={`set-voll-${e.id}`}>Vollzahlung eingegangen</button>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
